<template>
  <div class="gdpr-setting">
    <div class="gdpr-setting__header">
      <q-checkbox
        :model-value="modelValue"
        :disable="disabled"
        color="orange-9"
        keep-color
        @update:model-value="emit('update:modelValue', $event)"
      />
      <strong class="gdpr-setting__title">{{ title }}</strong>
    </div>
    <p class="gdpr-setting__description">{{ description }}</p>
  </div>
</template>

<script setup lang="ts">
defineProps<{
  title: string
  description: string
  modelValue: boolean
  disabled?: boolean
}>()

const emit = defineEmits<{
  (e: 'update:modelValue', value: boolean): void
}>()
</script>

<style scoped>
.gdpr-setting {
  margin-bottom: 12px;
}

.gdpr-setting__header {
  display: flex;
  align-items: center;
  gap: 4px;
}

.gdpr-setting__title {
  font-size: 14px;
  color: #1d1d1d;
}

.gdpr-setting__description {
  margin: 4px 0 0 40px;
  font-size: 13px;
  color: #555;
  line-height: 1.5;
}
</style>
